import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { trackAdvertiser } from "./trackAdvertiser";

export function PremierAgentCard({ advertiser }) {
  const advertiserId = advertiser?.id;
  const tracked = useRef(false);
  const [imgError, setImgError] = useState(false);
  useEffect(() => {
    if (!advertiserId || tracked.current) return;
    tracked.current = true;
    trackAdvertiser(advertiserId, "view");
  }, [advertiserId]);
  if (!advertiser) return null;
  const profileUrl = `/local-experts/${advertiser.slug}`;
  const handleClick = () => trackAdvertiser(advertiser.id, "click");
  const photo = !imgError && (advertiser.profile_photo_url || advertiser.logo_url);

  return (
    <div data-testid={`premier-agent-card-${advertiser.id}`} className="rounded-xl border border-[#E7E4DE] bg-white overflow-hidden flex flex-col items-center text-center p-6">
      <Link to={profileUrl} onClick={handleClick} data-testid={`premier-agent-profile-link-${advertiser.id}`} className="relative">
        {photo ? (
          <img src={photo} alt={advertiser.business_name} onError={() => setImgError(true)} className="h-24 w-24 rounded-full object-cover border-2 border-[#C7A361]" />
        ) : (
          <div className="h-24 w-24 rounded-full bg-[#F8F7F4] border-2 border-[#C7A361] grid place-items-center text-2xl font-serif-display text-[#667085]">{advertiser.business_name?.[0] || "?"}</div>
        )}
      </Link>
      <span className="mt-3 inline-block rounded-full bg-[#C7A361] text-[#111820] text-[9px] font-semibold uppercase tracking-[0.1em] px-3 py-1">Premier Agent</span>
      <Link to={profileUrl} onClick={handleClick} className="mt-2 font-serif-display text-lg text-[#202833] hover:text-[#C7A361] transition-colors">{advertiser.business_name}</Link>
      {advertiser.headline && <p className="text-xs text-[#667085] mt-0.5 leading-snug">{advertiser.headline}</p>}
      {advertiser.license_number && <p className="text-[11px] text-[#98A2B3] mt-0.5">Lic. #{advertiser.license_number}</p>}
      <div className="mt-4 flex items-center gap-2 w-full">
        {advertiser.contact_phone && <a href={`tel:${advertiser.contact_phone}`} onClick={handleClick} data-testid={`premier-agent-phone-${advertiser.id}`} className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full border border-[#E7E4DE] text-[#202833] text-xs font-medium py-2 hover:bg-[#F8F7F4] transition"><Phone size={13} />Call</a>}
        {advertiser.contact_email && <a href={`mailto:${advertiser.contact_email}`} onClick={handleClick} data-testid={`premier-agent-email-${advertiser.id}`} className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full border border-[#E7E4DE] text-[#202833] text-xs font-medium py-2 hover:bg-[#F8F7F4] transition"><Mail size={13} />Email</a>}
      </div>
    </div>
  );
}
